<template>
  <SFButton
    variant="raw"
    class="h-14 w-full !justify-start border-b border-gray-300 p-4"
    :class="buttonClass"
    @click="$emit('click')"
  >
    <IconBack :class="iconClass || 'size-4 text-gray-600'" />
    <SFNavigationTreeItem
      :class="itemClass"
      :navigation-item="navigationItem"
      :text-color="textColor"
      disabled-link
    />
  </SFButton>
</template>
<script setup lang="ts">
import type { NavigationTreeItem } from '@scayle/storefront-nuxt'
import { SFButton } from '#storefront-ui/components'
import SFNavigationTreeItem from '~/components/SFNavigationTreeItem.vue'

interface Props {
  navigationItem: NavigationTreeItem
  textColor?: string
  buttonClass?: string
  iconClass?: string
  itemClass?: string
}

defineProps<Props>()

type Emits = {
  (e: 'click'): void
}
defineEmits<Emits>()
</script>
